import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Popover, Transition } from '@headlessui/react';
import React, { Fragment, useState } from 'react';

export default function EmergencyPopover({ isMobile, type, titleSize }) {
  const [close2, setClose2] = useState();

  const emergencyHelpline = [
    {
      name: 'Police station',
      contact: 100,
    },
    {
      name: 'Doctor helpline',
      contact: 1911,
    },
    {
      name: 'Ambulance',
      contact: [108, 102],
    },
    {
      name: 'Hospital emergency number',
      contact: 104,
    },
    {
      name: 'Women helpline',
      contact: [181, 1091],
    },
    {
      name: 'Child helpline',
      contact: 1098,
    },
    {
      name: 'Rescue & relief helpline',
      contact: 1070,
    },
    {
      name: 'Fire',
      contact: 101,
    },
    {
      name: 'Central accident and trauma services',
      contact: 1099,
    },
  ];

  const controlRoom = [
    {
      name: 'Gandhinagar',
      contact: '079-23256720',
    },
    {
      name: 'Ahmedabad',
      contact: '079-27560511',
    },
    {
      name: 'Vadodara',
      contact: '0265-2427592',
    },
    {
      name: 'Surat',
      contact: '0261-2663200',
    },
    {
      name: 'Rajkot',
      contact: '0281-2471573',
    },
    {
      name: 'Bhavnagar (1)',
      contact: '0278-2521554',
    },
    {
      name: 'Bhavnagar (2)',
      contact: '0278-2521555',
    },
  ];

  // emergency, controlRoom

  const heading = type === 'emergency' ? 'Emergency Helpline No.' : 'Control Room';
  const contacts = type === 'emergency' ? emergencyHelpline : controlRoom;

  return (
    <Popover className="flex relative">
      {({ open }) => (
        <>
          <Popover.Button
            className={`${open ? 'text-opacity-90' : ''} truncate ${
              titleSize || 'text-sm'
            } ignore-style`}
          >
            {!isMobile ? (
              <span
                onClick={
                  open
                    ? () => {
                        close2 ? setClose2(false) : setClose2(true);
                      }
                    : () => setClose2(false)
                }
                className="underline"
              >
                {heading}
              </span>
            ) : (
              <FontAwesomeIcon icon={faInfoCircle} style={{ color: '#f00' }} />
            )}
          </Popover.Button>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
          >
            <Popover.Panel
              className={`absolute right-0 mt-7 z-10 w-80 ${close2 ? 'hidden' : 'block'}`}
            >
              <div className="overflow-hidden shadow-lg rounded-md">
                <div className="relative bg-yellow-viewVenue" onClick={() => setClose2(true)}>
                  <div
                    className={`flex flex-col justify-start cursor-pointer transition duration-150 ease-in-out hover:bg-pink-150 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50 py-2 border-1`}
                  >
                    <div className="mb-2 text-sm">{heading}</div>
                    {contacts.map((item, idx) => (
                      <div key={idx} className="flex ml-4">
                        <p className="text-sm mb-1 text-black font-semibold">{item.name} :- </p>
                        {Array.isArray(item.contact) ? (
                          item.contact.map((contact, i) => (
                            <a
                              key={contact}
                              className="text-sm font-semibold ml-2"
                              href={'tel:' + contact}
                            >
                              {contact} {i !== item.contact.length - 1 && ','}
                            </a>
                          ))
                        ) : (
                          <a className="text-sm font-semibold ml-2" href={'tel:' + item.contact}>
                            {item.contact}
                          </a>
                        )}
                      </div>
                    ))}
                    {heading === 'Control Room' && (
                      <a
                        target={'_blank'}
                        rel="noreferrer"
                        className="text-sm text-center font-semibold ml-2 underline"
                        href={'https://www.nationalgamesgujarat2022.info/directory'}
                      >
                        More numbers
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </Popover.Panel>
          </Transition>
        </>
      )}
    </Popover>
  );
}
